<template>
  <div>
    <v-dialog v-model="dialog" v-if="dialog" max-width="1000" scrollable>
      <v-card>
        <v-card-title>
          Revue d'un relevé de recharge
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>



          <div class="grid">
            <v-row dense>
              <v-col class="label">Période</v-col>
              <v-col class="text-capitalize">
                {{ statement.startDate | formatDate($t('format_month_str')) }}
              </v-col>
              <v-col class="label">Fournisseur</v-col>
              <v-col>
                {{ statement.externalOperatorSupplier }}
              </v-col>
            </v-row>
          </div>

          <headline class="mt-6">
            Détails déclarés par le client
          </headline>
          <div class="grid pt-0" v-if="statement.externalOperatorSupplier === 'ZEPLUG'">
            <v-row dense class="font-weight-thin">
              <v-col cols="3">
              </v-col>
              <v-col cols="3" class="justify-end font-weight-thin">
                Energie
              </v-col>
              <v-col cols="3" class="justify-end font-weight-thin">
                Montant HT
              </v-col>
              <v-col cols="3" class="justify-end font-weight-thin">
                Montant TTC
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="3" class="label">
                Heure creuse*
              </v-col>
              <v-col cols="3" class="justify-end font-weight-thin">
                {{ statement.data.offPeak?.consumption ? statement.data.offPeak.consumption.toFixed(3) : '0,000' }} kWh
              </v-col>
              <v-col cols="3" class="justify-end font-weight-thin">
                {{ statement.data.offPeak?.amount ? statement.data.offPeak.amount.toFixed(2) : '0,00' }} € HT
              </v-col>
              <v-col cols="3" class="justify-end font-weight-thin">
                {{ statement.data.offPeak?.amountIncludingVat ? statement.data.offPeak.amountIncludingVat.toFixed(2) : '0,00' }} € TTC
              </v-col>
            </v-row>
            <v-row dense>
              <v-col class="label">
                Heure pleine
              </v-col>
              <v-col cols="3" class="justify-end font-weight-thin">
                {{ statement.data.peak?.consumption ? statement.data.peak.consumption.toFixed(3) : '0,000' }} kWh
              </v-col>
              <v-col cols="3" class="justify-end font-weight-thin">
                {{ statement.data.peak?.amount ? statement.data.peak.amount.toFixed(2) : '0,00' }} € HT
              </v-col>
              <v-col cols="3" class="justify-end font-weight-thin">
                {{ statement.data.peak?.amountIncludingVat ? statement.data.peak.amountIncludingVat.toFixed(2) : '0,00' }} € TTC
              </v-col>
            </v-row>
            <v-row dense>
              <v-col class="label">
                Abonnement
              </v-col>
              <v-col cols="3">-</v-col>
              <v-col cols="3" class="justify-end font-weight-thin">
                {{ statement.data.subscription?.amount ? statement.data.subscription.amount.toFixed(2) : '0,00' }} € HT
              </v-col>
              <v-col cols="3" class="justify-end font-weight-thin">
                {{ statement.data.subscription?.amountIncludingVat ? statement.data.subscription.amountIncludingVat.toFixed(2) : '0,00' }} € TTC
              </v-col>
            </v-row>
            <v-row dense>
              <v-col class="label">
                Total
              </v-col>
              <v-col cols="3" class="justify-end">
                {{ total.consumption.toFixed(3) }} kWh
              </v-col>
              <v-col cols="3" class="justify-end  font-weight-thin">
                {{ total.amount.toFixed(2) }} € HT
              </v-col>
              <v-col cols="3" class="justify-end">
                {{ total.amountIncludingVat.toFixed(2) }} € TTC
              </v-col>
            </v-row>

          </div>

          <div class="grid pt-0" v-if="statement.externalOperatorSupplier === 'STANDARD'">
            <v-row dense class="font-weight-thin">
              <v-col cols="4" class="label">
                Energie
              </v-col>
              <v-col cols="4" class="justify-end">
                {{ statement.data.global?.consumption ? statement.data.global.consumption.toFixed(3) : '0,000' }} kWh
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="4" class="label">
                Montant TTC
              </v-col>
              <v-col cols="4" class="justify-end">
                {{ statement.data.global?.amountIncludingVat ? statement.data.global.amountIncludingVat.toFixed(2) : '0,00' }} € TTC
              </v-col>
            </v-row>

          </div>

          <headline class="mt-6">
            Facture fournie par le client
          </headline>
          <v-row dense class="py-3" v-if="statement.attachments?.length > 0">
            <v-col class="text-center">
              <div class="d-flex flex-wrap justify-center" style="gap: 10px">
                <v-btn v-for="attachment in statement.attachments" :key="attachment._id" small @click="viewFile(statement)" outlined>
                  {{ statement.attachments[0].filename }} ({{ (statement.attachments[0].size/1000).toFixed(2) }} ko)
                </v-btn>
              </div>
            </v-col>
          </v-row>


          <div class="grid" v-if="statement.status !== 'rejected'">
            <headline v-if="statement.status === 'accepted'" class="mt-6">Données finales validées</headline>
            <headline v-else class="mt-6">Données finales pour validation</headline>
            <v-row dense class="justify-center">
              <v-col cols="3" class="label">
                Période
              </v-col>
              <v-col cols="6">
                <date-picker
                    v-model="correctedPeriod"
                    type="month"
                    :readonly="statement.status === 'accepted'"
                    :rules="[rules.required]"
                    hide-details
                    solo
                    :allowed-dates="allowedMonths"
                />
              </v-col>
            </v-row>
            <v-row dense class="justify-center">
              <v-col cols="3" class="label">
                Energie (kWh)
              </v-col>
              <v-col cols="6">
                <v-text-field
                    v-model.number="correctedEnergy"
                    type="number"
                    min="0"
                    max="1000000"
                    :readonly="statement.status === 'accepted'"
                    solo
                    hide-details
                    :rules="[rules.required]"
                />
              </v-col>
            </v-row>
            <v-row dense class="justify-center">
              <v-col cols="3" class="label">
                Montant TTC (€)
              </v-col>
              <v-col cols="6">
                <v-text-field
                    v-model.number="correctedAmount"
                    type="number"
                    min="0"
                    max="1000000"
                    hide-details
                    :readonly="statement.status === 'accepted'"
                    solo
                    :rules="[rules.required]"
                />
              </v-col>
            </v-row>
          </div>


          <template v-if="statement.status === 'pending'">
            <v-row dense>
              <v-col>
                <v-alert type="info" dense>
                  Vérifiez que la facture est lisible et que les montants, périodes, et kWh correspondent aux données ci-dessus.
                </v-alert>
              </v-col>
            </v-row>


            <headline class="mt-6">
              Que souhaitez-vous faire avec ce relevé ?
            </headline>
            <v-row dense>
              <v-col class="text-center">
                <v-btn  color="error" @click="reject">
                  Rejeter
                </v-btn>
                <v-btn class="ml-3" color="success" @click="validate">
                  Valider
                </v-btn>
              </v-col>
            </v-row>
          </template>

          <template v-if="statement.status === 'rejected'">
            <headline class="mt-6">
              Relevé rejeté
            </headline>
            <v-row dense>
              <v-col class="text-center">
                Ce relevé a été rejeté
                <template v-if="statement.reviewedBy">
                  par <b>{{ statement.reviewedBy.firstname }} {{ statement.reviewedBy.lastname }}</b> le <b>{{ statement.reviewedAt | formatDate}}</b>.
                </template>
                <template v-if="statement.rejectReason">
                  pour la raison suivante :
                 <div class="red--text">
                   {{ statement.rejectReason }}
                 </div>
                </template>
              </v-col>
            </v-row>
          </template>

          <template v-if="statement.status === 'accepted'">
            <headline class="mt-6">
              Relevé accepté
            </headline>
            <v-row dense>
              <v-col class="text-center">
                Ce relevé a été validé
                <template v-if="statement.reviewedBy">
                  par <b>{{ statement.reviewedBy.firstname }} {{ statement.reviewedBy.lastname }}</b> le <b>{{ statement.reviewedAt | formatDate}}</b>.
                </template>
               <div class="green--text" v-if="statement.cdrId">
                 Id du CDR : {{ statement.cdrId}}
               </div>
              </v-col>
            </v-row>
          </template>



        </v-card-text>
        <v-divider></v-divider>

        <v-card-actions>
          <v-row class="ma-0">
            <v-col class="text-right">
              <v-btn small color="primary" @click="close">
                {{ $t('close')}}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>

      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogReject" v-if="dialogReject" max-width="1000" scrollable>
      <v-card>
        <v-card-title>
          Rejecter de relevé
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-textarea v-model="rejectReason"></v-textarea>

        </v-card-text>
        <v-divider></v-divider>

        <v-card-actions>
          <v-row class="ma-0">
            <v-col class="text-right">
              <v-btn small @click="closeReject">
                {{ $t('close')}}
              </v-btn>
              <v-btn class="ml-3" small color="primary" :disabled="!rejectReason?.trim()" @click="confirmReject">
                Rejeter le relevé
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <file-viewer ref="fileViewer" />
  </div>
</template>

<script>
import MeterDeviceRepository from "@repository/MeterDeviceRepository";
import RegisterExternalInvoiceMixin from "@pages/MeterDevice/RegisterExternalInvoice/RegisterExternalInvoiceMixin";
import dayjs from "dayjs";
import FileViewer from "../../../../modals/FileViewer.vue";
import Tools from "../../../../../includes/tools";

export default {
  components: {
    FileViewer,
  },
  data() {
    return {
      dialog: false,
      dialogReject: false,
      statement: null,
      correctedEnergy: null,
      correctedAmount: null,
      correctedStartDate: null,
      correctedEndDate: null,
      rejectReason: null,
      meterDevice: null,
    }
  },

  props: {
    openUsagesAfterValidate: Boolean,
  },

  mixins: [
    RegisterExternalInvoiceMixin,
  ],

  computed: {


    total() {
      return {
        consumption: this.statement.data.offPeak.consumption + this.statement.data.peak.consumption,
        amount: this.statement.data.offPeak.amount + this.statement.data.peak.amount + this.statement.data.subscription.amount,
        amountIncludingVat: this.statement.data.offPeak.amountIncludingVat + this.statement.data.peak.amountIncludingVat + this.statement.data.subscription.amountIncludingVat,
      }
    },

    correctedPeriod: {
      get() {
        return dayjs(this.correctedStartDate).format("YYYY-MM")
      },
      set(val) {
        this.correctedStartDate = dayjs(val, 'YYYY-MM').format('YYYY-MM-DD 00:00:00')
        this.correctedEndDate = dayjs(val, 'YYYY-MM').endOf('month').format('YYYY-MM-DD 23:59:59')
      }
    }
  },

  watch: {
    dialog(val) {
      if(!val) {
        this.resetData()
      }
    }
  },

  mounted() {

  },

  methods: {

    resetData() {
      this.statement = null
      this.correctedEnergy = null
      this.correctedAmount = null
      this.correctedStartDate = null
      this.correctedEndDate = null
    },

    open(statement, meterDevice) {
      this.statement = statement
      this.meterDevice = meterDevice

      this.correctedEnergy = statement.energy
      this.correctedAmount = statement.amount
      this.correctedStartDate = statement.startDate
      this.correctedEndDate = statement.endDate
      this.dialog = true
    },

    close() {
      this.resetData()
      this.dialog = false
    },

    closeReject() {
      this.dialogReject = false
    },

    openFile(statement) {
      this.showLoading(true)
      MeterDeviceRepository.downloadStatement(statement.id).then(() => {
        this.showLoading(false)
      }).catch(err => {
        this.notifyError(err)
        this.showLoading(false)
      })
    },

    viewFile(statement) {
      this.showLoading(true)
      MeterDeviceRepository.downloadStatementAsBase64(statement.id).then(({arrayBuffer, type, filename}) => {
        this.showLoading(false)
        this.$refs.fileViewer.open(arrayBuffer, type, filename)
      }).catch(err => {
        this.notifyError(err)
        this.showLoading(false)
      })
    },

    validate() {
      this.$dialog.confirm({text: this.$t('are-you-sure')}).then(result => {
        if(result) {
          this.showLoading(true)
          MeterDeviceRepository.validateStatement(this.statement.id, this.correctedStartDate, this.correctedEndDate, this.correctedEnergy * 1000, this.correctedAmount,).then(() => {
            this.showLoading(false)
            this.$parent.loadData()
            if(this.openUsagesAfterValidate) {
              window.open(this.$router.resolve({name: 'meter-device.usages', params: {id: this.meterDevice.id}}).href, '_blank')
            }
            this.close()
          }).catch(err => {
            this.notifyError(err)
            this.showLoading(false)
          })
        }
      })
    },

    reject() {
      this.rejectReason = null
      this.dialogReject = true
    },

    confirmReject() {
      this.$dialog.confirm({text: this.$t('are-you-sure')}).then(result => {
        if(result) {
          this.showLoading(true)
          MeterDeviceRepository.rejectStatement(this.statement.id, this.rejectReason).then(() => {
            this.showLoading(false)
            this.closeReject()
            this.$parent.loadData()
            this.close()
          }).catch(err => {
            this.notifyError(err)
            this.showLoading(false)
          })
        }
      })
    }

  }
}
</script>

<style lang="scss">
.meter-device-external-operator-statements {

}
</style>